import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-100 px-4 md:px-6 lg:px-8 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
            内容分类导航
          </h2>
          <p className="text-sm text-foreground-500">探索你感兴趣的吃瓜内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300/50 hover:bg-primary-50/50 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-primary-700`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-400">{cat.articleCount}篇文章</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}